import { useState } from 'react';

export const useModalManager = () => {
  const [modals, setModals] = useState({
    task: { show: false, taskId: null, mode: 'create' },
    comments: { show: false, taskId: null, comments: [], loading: false },
    attachments: { show: false, taskId: null, attachments: [], loading: false },
    actionComments: { show: false, taskId: null, comments: [], loading: false },
    deadlineHistory: { show: false, taskId: null, deadlines: [], loading: false }
  });

  const openModal = (modalName, data = {}) => {
    setModals(prev => ({
      ...prev,
      [modalName]: { ...prev[modalName], show: true, ...data }
    }));
  };

  const closeModal = (modalName) => {
    setModals(prev => ({
      ...prev,
      [modalName]: { ...prev[modalName], show: false }
    }));
  };

  return { modals, openModal, closeModal };
};